import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { Component } from "react";
import { Animated } from "react-animated-css";
import { Container, Jumbotron } from "reactstrap";
import "../../App.css";

class Portfolio extends Component {
  render() {
    return (
      <Container>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Jumbotron>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./1.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>

            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./2.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./3.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./12.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./10.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>

            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./23.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./7.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./111.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundImage: "url(./9.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./11.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./4.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundImage: "url(./5.jpg)",
                  paddingBottom: "95%",
                }}
              />
            </div>
          </Jumbotron>
        </Animated>
      </Container>
    );
  }
}

export default Portfolio;
